import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,  MenuItem, Grid, Button, Paper, IconButton,
  Stack,
  Select,
  CircularProgress,
} from '@mui/material';
import { align_center,  btnstyle, VM_Colors } from '../../Styles/VMStyles';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import StorageFactory from '../../Util/StorageFactory';
import {  ROUTE_ADD_ENQUIRY, SESSION_USER_ID_KEY, UPDATE, LEAD_SOURCE_OPTIONS } from '../../Util/VMConstants';
import { API_ADD_ENQUIRY, API_GET_ENQUIRY_DETAILS, API_UPDATE_ENQUIRY } from '../../Util/URLConstants';
import { resetForm, setEnquiryID, updateCustomerField } from '../../Redux/slices/addEnquirySlice';
import FormFieldValues from '../../Components/Custom/FormFieldValues';
import { world_phoneCodes } from '../../Util/ConstnatUtils';
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from 'react-multi-date-picker';
import { formattedDates, isEmpty, returnDate, toPickerDate, toTitleCase } from '../../Util/UtilHelper';
import { useNavigate } from 'react-router-dom';
import Loader from '../../Components/Loader';
import StyledInputField from '../../Components/Custom/StyledInputField';
import MuiTypographyMandatory from '../../Components/Custom/MuiTypographyMandatory';
import MUITypography from '../../Components/MUITypography';



function AECustomerDetails({ enquiry_id ,arrived}) {

  const navigate = useNavigate();  
  const customer = useSelector((state) => state.addEnquiry.customer);
  const dispatch = useDispatch();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [loading,setLoading] =useState(false);
  const [errors, setErrors] = useState({});
  const [leadOption, setLeadOption] = useState('');
  const [customLead, setCustomLead] = useState('');
  const sessionFactory = new StorageFactory('session');
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);
  // const countryCode = "+"+sessionFactory.get(SESSION_USER_COUNTRY_CODE_KEY);

  const handleChange = (field) => (e) => {
    let value = e.target.value;

    if (field === 'phone_no') {
      value = value.replace(/\D/g, '');
      if (value.length >= 15) {
        value = value.slice(0, 15);
      }
    }

    dispatch(updateCustomerField({ field, value }));
     // Live validation for red border removal
     
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      if (field === 'name' && value.trim().length >= 1) delete updatedErrors.name;
      if (field === 'phone_no' && value.trim().length >= 1) delete updatedErrors.phone_no;
      if (field === 'country_code' && value) delete updatedErrors.country_code;
      if (field === 'appointment_date' && Array.isArray(value) && value.length > 0)
        delete updatedErrors.appointment_date;
      if (field === 'lead' && value) delete updatedErrors.lead;
      return updatedErrors;
    });
  };

  const isPresetLead = (value) =>
    LEAD_SOURCE_OPTIONS.includes(value) && value !== 'Others';

  const handleLeadOptionChange = (e) => {
    const value = e.target.value;
    setLeadOption(value);
    if (value === 'Others') {
      dispatch(updateCustomerField({ field: 'lead', value: customLead.trim() }));
    } else {
      setCustomLead('');
      dispatch(updateCustomerField({ field: 'lead', value }));
    }
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors.lead;
      if (value !== 'Others') delete updatedErrors.customLead;
      return updatedErrors;
    });
  };

  const handleCustomLeadChange = (e) => {
    const value = e.target.value;
    setCustomLead(value);
    dispatch(updateCustomerField({ field: 'lead', value }));
    if (value.trim()) {
      setErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors.customLead;
        delete updatedErrors.lead;
        return updatedErrors;
      });
    }
  };
  // dispatch(updateCustomerField({ field: 'country_code', value: countryCode }));
  
  const validateCustomerDetails = () => {
    const { name, country_code, phone_no,  appointment_date } = customer;
    const newErrors = {};

    if (!name || name.trim().length < 2) newErrors.name = true;
    if (!country_code) newErrors.country_code = true;

    const phoneRegex = /^[0-9]{7,15}$/;
    if (!phone_no || !phoneRegex.test(phone_no)) newErrors.phone_no = true;


    if (!Array.isArray(appointment_date) || appointment_date.length === 0) newErrors.appointment_date = true;
    if (!leadOption) newErrors.lead = true;
    if (leadOption === 'Others' && !customLead.trim()) newErrors.customLead = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};


  const fetchEnquiryDetails = useCallback(async () => {
    setLoading(true);
      if (enquiry_id) {
        setIsPreview(true);
        try {
          const response = await axios.get(API_GET_ENQUIRY_DETAILS, {
            params: { enquiry_id },
          });

           setLoading(false);
          const data = response.data;
          if (data.status_code === 200 ) {
           const details = data?.enquiry_info;
       
            const appointmentDates = formattedDates(details.appointment_date || []);
            const savedLead = details.lead || '';
            const usingCustomLead = Boolean(savedLead) && !isPresetLead(savedLead);
            setLeadOption(usingCustomLead ? 'Others' : savedLead);
            setCustomLead(usingCustomLead && savedLead !== 'Others' ? savedLead : '');
            const customerData = {
              name: details.name || '',
              phone_no: details.phone_no || '',
              country_code: details.country_code || '',
              email: details.email || '',
              appointment_date: appointmentDates,
              address: details.address || '',
              notes: details.notes || '',
              lead: savedLead,
              enquiry_id: enquiry_id,
              user_id  : userID
            };

            setSelectedDates(appointmentDates.map(toPickerDate).filter(Boolean));
            Object.entries(customerData).forEach(([field, value]) => {
              dispatch(updateCustomerField({ field, value }));
            });
          } else {
            toast.error(data.message || 'Failed to fetch enquiry details');
          }
        } catch (error) {
          console.error(error);
           setLoading(false);
          
          toast.error('Error fetching enquiry details');
        }
      } else {
        setIsPreview(false);
      }
       setLoading(false);
          
    }, [dispatch, enquiry_id, userID]);

  const submitHandler = async () => {
    if (!validateCustomerDetails()) return;

    setButtonLoading(true);

    const reqBody = {
      ...customer,
      user_id  : userID,
      lead: leadOption === 'Others' ? customLead.trim() : leadOption,
    };
    let url ="";

    reqBody.appointment_date =  formattedDates(customer.appointment_date); //Add Enquiry
     
    if(isEmpty(customer.enquiry_id)){
      url = API_ADD_ENQUIRY;
    }else{
      reqBody.appointment_id = customer.enquiry_id; //Update Enquiry
       url = API_UPDATE_ENQUIRY;
    }


    console.log("reqBody:",reqBody);
    try {
      const response = await axios.post( url , reqBody, {
        headers: { 'Content-Type': 'application/json' },
      });

      const respData = response.data;

      if (respData.status_code === 200) {
        dispatch(setEnquiryID(respData.enquiry_id));
        setIsPreview(true);
        toast.success(respData.message);
        dispatch(resetForm());
        await fetchEnquiryDetails();
        navigate('/' + ROUTE_ADD_ENQUIRY, { state: { enquiry_id: respData.enquiry_id, arrived: UPDATE } });
      } else {
        toast.error(respData.message);
      }
    } catch (error) {
      toast.error('Something went wrong!');
    } finally {
      setButtonLoading(false);
    }
  };

  useEffect(() => {
  
    fetchEnquiryDetails();
  }, [fetchEnquiryDetails]);

  const renderCustomerPreview = () => {
    return (
      <Paper sx={{ backgroundColor: VM_Colors.white2, padding: 2 }}>
        <Grid container spacing={5}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Name" subtitle={customer.name} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Mobile" subtitle={customer.country_code + " " + customer.phone_no} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Email" subtitle={customer.email} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues
              title="Event Dates"
              subtitle={Array.isArray(customer.appointment_date)
                        ? customer.appointment_date.map(dateStr =>returnDate(dateStr) ).join(', ')
                        : returnDate(customer.appointment_date)
                      }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Address" subtitle={customer.address} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Lead Source" subtitle={customer.lead} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <FormFieldValues title="Notes" subtitle={customer.notes} />
          </Grid>
        </Grid>
      </Paper>
    );
  };

  const normalizeCode = (code) => {
  if (!code && code !== 0) return '';
  return String(code).startsWith('+') ? String(code) : `+${String(code)}`;
};

// build options array (inside component, above JSX)
const normalizedCustomerCode = normalizeCode(customer.country_code);
const hasCurrentInList = world_phoneCodes.some(
  (ctr) => normalizeCode(ctr.code) === normalizedCustomerCode
);

// create options: if current code not found, add a fallback item at top
const phoneCodeOptions = hasCurrentInList
  ? world_phoneCodes
  : [{ code: normalizedCustomerCode, country: normalizedCustomerCode }, ...world_phoneCodes];

  const renderAddCustomerData = () => {
    const handleDateChange = (dates) => {
      const normalized = formattedDates(dates);
      setSelectedDates(normalized.map(toPickerDate));
      dispatch(updateCustomerField({
        field: 'appointment_date',
        value: normalized
      }));
     setErrors((prev) => {
      const updatedErrors = { ...prev };
      if (Array.isArray(dates) && dates.length > 0)
        delete updatedErrors.appointment_date;
      return updatedErrors;
    });
    };

    return (
      <Paper sx={{ backgroundColor: VM_Colors.white2, padding: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>

       <StyledInputField
            heading="Name"
            name="name"
            placeholder={toTitleCase("Enter Name")}
            value={customer.name}
            onChange={handleChange('name')}
            fullWidth
            required={true}
            style={{ mt: 1 }}
            error={Boolean(errors.name)} 
          />
           
          </Grid>
          <Grid item xs={4} sm={2} md={1.5}>
           <Stack spacing={0.5} sx={{minWidth:'200px', mr:2}}>
            <MuiTypographyMandatory label="Country Code" required />
            <Select
                name="Code"
                value={customer.country_code }
                
                 onChange={(e) => {
                  // store value normalized (with +)
                  const val = normalizeCode(e.target.value);
                  handleChange('country_code')({ target: { value: val } });
                }}
                renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "#9e9e9e", fontSize: "15px" }}>
                          Select Country
                        </span>
                      );
                    }
                    return selected;
                  }}
                sx={{
                  minWidth: "100px",
                  border: errors.country_code ? '1px solid red' : undefined,
                  borderRadius: 1,
                  backgroundColor: VM_Colors.white,
                   "& .MuiSelect-select": {
                    fontSize: "15px",
                  },
                }}
                displayEmpty
              >
              <MenuItem value="" disabled>
                -- Select --
              </MenuItem>
                {phoneCodeOptions.map((ctr) => {
                    const codeStr = normalizeCode(ctr.code);
                    const label = ctr.country && ctr.country !== codeStr ? `${ctr.country} (${codeStr})` : codeStr;
                    return (
                      <MenuItem key={codeStr} value={codeStr}>
                        {label}
                      </MenuItem>
                    );
                  })}

              </Select>
          </Stack>
          
          </Grid>
          <Grid item xs={8} sm={4} md={2.5}>
         <StyledInputField
            heading="Phone Number"
            name="number"
            type="number"
            required={true}
            placeholder={toTitleCase("Enter Phone Number")}
            value={customer.phone_no}
            onChange={handleChange("phone_no")}
            inputProps={{ 
              maxLength: 15, 
              inputMode: "numeric", // for mobile number keypad
              pattern: "[0-9]*",    // ensures only numbers
            }}
            style={{ mt: 1 }}
            error={Boolean(errors.phone_no)}
          />

          </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <StyledInputField
             heading="Email ID (Optional)"
             name="email"
             placeholder={toTitleCase("Enter EmailID")}
             required={false}
             value={customer.email}
             onChange={handleChange('email')}
             style={{ mt: 1 }}
             error={Boolean(errors.email)}
        
          />
          
          </Grid>
          <Grid item xs={12} sm={6} md={3}> 
          <Stack spacing={0.5} sx={{minWidth:'200px',}}>
            <MuiTypographyMandatory label="Event Dates" required />
         
            <DatePicker
              multiple
              value={selectedDates}
              onChange={handleDateChange}
              format="DD-MM-YYYY"
              placeholder={toTitleCase("Select Event Dates")}
              minDate={new Date()} 
              // style={{ width: "auto",minWidth:'190px',minHeight:'50px' ,backgroundColor:VM_Colors.tansparent ,fontSize:'16px'}}
              style={{
                width: "auto",
                minWidth: '190px',
                minHeight: '50px',
                backgroundColor: VM_Colors.transparent,
                fontSize: '16px',
                border: errors.appointment_date ? '1px solid red' : '1px solid #ccc',
                borderRadius: '4px',
              }}
           />
            </Stack>
        </Grid> 
        <Grid item xs={12} sm={6} md={3}>
          <StyledInputField
             heading="Address (Optional)"
             name="address"
             placeholder={toTitleCase("Enter Address")}
             required={false}
             value={customer.address}
             onChange={handleChange('address')}
             style={{ mt: 1 }}
            //  error={Boolean(errors.address)}
        
          />
          
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Stack spacing={0.5} sx={{ minWidth: '200px' }}>
              <MuiTypographyMandatory label="Lead Source" required />
              <Select
                name="lead"
                value={leadOption}
                onChange={handleLeadOptionChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <span style={{ color: "#9e9e9e", fontSize: "15px" }}>
                        Select Lead Source
                      </span>
                    );
                  }
                  return selected;
                }}
                sx={{
                  backgroundColor: VM_Colors.white,
                  border: errors.lead ? '1px solid red' : undefined,
                  borderRadius: 1,
                  "& .MuiSelect-select": {
                    fontSize: "15px",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  -- Select --
                </MenuItem>
                {LEAD_SOURCE_OPTIONS.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          </Grid>

          {leadOption === 'Others' ? (
            <Grid item xs={12} sm={6} md={3}>
              <StyledInputField
                heading="Lead Source Name"
                name="custom_lead"
                required
                placeholder={toTitleCase("Enter Lead Source")}
                value={customLead}
                onChange={handleCustomLeadChange}
                style={{ mt: 1 }}
                error={Boolean(errors.customLead)}
              />
            </Grid>
          ) : null}

        </Grid>

        <Box mt={2}>
         <StyledInputField
          heading="Notes (Optional)"
          name="notes"
          multiline
          minRows={4}
          placeholder={toTitleCase("Enter Note")}
          required={false}
          fullWidth
          value={customer.notes}
          onChange={handleChange('notes')}
          style={{ mt: 1 }}
          // error={Boolean(errors.notes)}
        
          />
        </Box>

       <Box sx={align_center} pt={5} pb={5} >
         <Button
          style={btnstyle}
          type="button"
          color="primary"
          variant="contained"
          sx={{ pl: 20, pr: 20 }}
          onClick={submitHandler}
          disabled={buttonLoading}
          startIcon={
            buttonLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : null
          }
        >
          {buttonLoading ? 'Saving...' : 'Save & Continue'}
        </Button>
       </Box>
      </Paper>
    );
  };

  return (
    <Box sx={{ pt: 2, borderRadius: 2, backgroundColor: 'background.paper', mb: 4 }}>
      <Loader loading={loading} />
      <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2, // optional bottom margin
          }}
        >
          <MUITypography  variant='h4' sx={{ fontWeight: 700 }}>
            {isPreview
              ? `Enquiry Details ( ${customer.enquiry_id} )`
              : 'Enquiry Details' 
            }
          </MUITypography>
        {
          isPreview
          ?  <IconButton
            aria-label="edit"
            onClick={()=>{
              setSelectedDates(
                (customer.appointment_date || []).map(toPickerDate).filter(Boolean)
              );
              setIsPreview(false);
            }}
            sx={{ width: 'auto' }}
          >
            <EditIcon />
          </IconButton>
          :null
        }
        </Box>

      {isPreview ? renderCustomerPreview() : renderAddCustomerData()}
    </Box>
  );
}
 
export default AECustomerDetails;
